<template>
  <div id="app">
    <keep-alive>
      <router-view class="cgs-app-content" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view class="cgs-app-content" v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
    let _this = this
    let first = null;
    document.addEventListener('plusready', function () {


      plus.geolocation.getCurrentPosition(async (position) => {
        let getLongitude = position.coords.longitude;
        let getLatitude = position.coords.latitude;
        console.log(position)

      }, (error) => {
        var errorType = [
          "您拒绝共享位置信息",
          "获取不到位置信息",
          "获取位置信息超时"
        ];
        plus.nativeUI.alert(errorType[error.code - 1]);
      }, {
        enableHighAccuracy: true
      });






      plus.key.addEventListener('backbutton', () => {
        if (window.__StopGlobleBackButton === undefined || !window.__StopGlobleBackButton) {
          if (_this.$route?.meta?.leaveAppBack) {
            plus.runtime.quit();
            plus.runtime.restart()
          } else {
            _this.$router.go(-1)
          }
        }

      });
    });
  },
  created(){ 
    this.$ws.init();
  }
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  color: #000
}

#app .cgs-app-content {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
